import { singletonFactory } from '@warehouse/shared/util';
import { QuickbaseNavbarService } from './quickbase.nav-bar.service';
import { QuickbaseServiceImpl } from './quickbase.nav-bar.service.impl';
import { NavbarType } from '../quickbase-types';

const quickbaseServiceSingletons: Record<NavbarType, ReturnType<typeof singletonFactory<QuickbaseNavbarService>>> = {
	[NavbarType.Utilities]: singletonFactory({
		factory: () => new QuickbaseServiceImpl(NavbarType.Utilities),
	}),

	[NavbarType.Dashboard]: singletonFactory({
		factory: () => new QuickbaseServiceImpl(NavbarType.Dashboard),
	}),

	[NavbarType.Admin]: singletonFactory({
		factory: () => new QuickbaseServiceImpl(NavbarType.Admin),
	}),

	[NavbarType.Orders]: singletonFactory({
		factory: () => new QuickbaseServiceImpl(NavbarType.Orders),
	}),
	[NavbarType.Inventory]: singletonFactory({
		factory: () => new QuickbaseServiceImpl(NavbarType.Inventory),
	}),
};

export const getQuickbaseSingleton = (type: NavbarType): ReturnType<typeof singletonFactory<QuickbaseNavbarService>> =>
	quickbaseServiceSingletons[type];
